import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Debts } from './Debts';
import { Button } from '../../components/Button';
import { accessor } from '../../helpers';
import { OfficeSwitcher } from '../../widgets/OfficeSwitcher';
import { Preloader } from '../../components/Preloader';
import { Navigate } from 'react-router-dom';
import { EmptyPage } from '../EmptyPage';
import { getOfficeData } from '../../redux/officeSlice';
import { Revenues } from './Revenues';
import { Expenses } from './Expenses';
import { CreateExpense } from './CreateExpense';
import { Categories } from './Categories';
import { CreateRevenue } from './CreateRevenue';

export const OfficePage = () => {
    const months = useSelector(state=> state.office.months);
    const cities = useSelector(state => state.settings.officeCities);
    const user = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const activeMonth = months.find(m => m.active);
    const isLastMonth = activeMonth.timestamp === months[months.length-1].timestamp;
    
    const isLoaded = useSelector((state) => state.office.isLoaded);
    const officeError = useSelector((state) => state.office.error);
    const segmentError = useSelector((state) => state.office.segmentError);
    const officeAccess = accessor.office(user);

    const handOverAccess = accessor.handOver(user);
    const createExpensesAccess = accessor.createExpenses(user);

    const revenues = useSelector((state) => state.office.revenues);
    const expenses = useSelector((state) => state.office.expenses);
    const officeInfo = useSelector((state) => state.office.balances);
    const expenseCategories = useSelector((state) => state.settings.expenseCategories);
    useEffect(() => {
        dispatch(getOfficeData({
          month: activeMonth.month
      }));
    }, []);

    const [city, setCity] = useState(cities.length ? cities[0]._id : null);

    const filteredRevenues = revenues.filter(r => r.city._id === city && r.monthStamp === activeMonth.timestamp);
    const filteredExpenses = expenses.filter(e => e.city._id === city && e.monthStamp === activeMonth.timestamp);

    const ordersToHandOver = useSelector((state) => state.orders.list)
    .filter(o => o.handOver > 0 && !o.details.isHandOver).filter(o => o.details.monthStamp === activeMonth.timestamp && o.city._id === city);
    
    const [expensePopup, setExpensePopup] = useState(false);
    const [revenuePopup, setRevenuePopup] = useState(false);
    const [categoryPopup, setCategoryPopup] = useState(false);

    if (!isLoaded) {
        return <Preloader />
      }
      if (!officeAccess) {
        return <Navigate to="/users" />
      }
      if (officeError) {
        return <EmptyPage message={officeError}/>
      }
    
    const infoAccess = accessor.revenues(user) && accessor.expenses(user);
    const thisInfo = officeInfo.find(b => b.timestamp === activeMonth.timestamp && b.city === city);
    return (
        <section className="office-page page">
            <div className="office__manager">
                {infoAccess && <div className='office__manager-info'>
                    <div>
                        <span>Стартовый:</span>
                        <span>{thisInfo?.startBalance.toLocaleString('fr-FR')} ₽</span>
                    </div>
                    <div>
                        <span>Доходы:</span>
                        <span>{thisInfo?.revenue.toLocaleString('fr-FR')} ₽</span>
                    </div>
                    <div>
                        <span>Расходы:</span>
                        <span>{thisInfo?.expense.toLocaleString('fr-FR')} ₽</span>
                    </div>
                    <div>
                        <span>{isLastMonth ? 'Баланс' : 'Остаток'}:</span>
                        <span>{thisInfo?.totalBalance.toLocaleString('fr-FR')} ₽</span>
                    </div>
                </div>}
                <div className='office__manager-cities'>
                    {cities.length ? <><span>Город: </span>
                    {cities.map(c => <button className={`button ${city === c._id ? 'active' : ''}`} key={c._id} onClick={() => setCity(c._id)}>{c.name}</button>)}
                    </>: <div>Нет доступных касс</div>}
                    </div>
                <div className='office__manager-buttons'>
                    {handOverAccess ? <Button text='Добавить Доход' onClick={() => setRevenuePopup(true)}/> : null}
                    {createExpensesAccess ? <Button text='Добавить расход' onClick={() => setExpensePopup(true)}/> : null}
                    {createExpensesAccess ? <Button text='Категории' onClick={() => setCategoryPopup(true)}/> : null}
                </div>
            </div>
            {revenuePopup && <CreateRevenue city={city} monthStamp={activeMonth.timestamp} closeFn={() => setRevenuePopup(false)} />}
            {expensePopup && <CreateExpense city={city} monthStamp={activeMonth.timestamp} closeFn={() => setExpensePopup(false)} />}
            {categoryPopup && <Categories list={expenseCategories} closeFn={() => setCategoryPopup(false)} />}
            <div className="office-container">
                {handOverAccess ? <Debts revenues={filteredRevenues} error={segmentError.orders} month={activeMonth} orders={ordersToHandOver} /> : null}
                <div className="office__table">
                    <Revenues error={segmentError.revenues} list={filteredRevenues}/>
                    <Expenses categories={expenseCategories} error={segmentError.expenses} list={filteredExpenses}/>
                </div>
            </div>
            <OfficeSwitcher months={months} />
        </section>
    );
};
